import Interaction from "../../../models/interactions/Interaction";

export default function TriggerNodePreview(props: {
  nodeId: string;
  interaction: Interaction;
}) {
  void props;

  return (
    <div className="flex w-full items-center pt-[2px] pb-[8px]">
      <span className="truncate text-[12px] font-medium text-creator-text-soft uppercase tracking-wide">
        Parallel nodes
      </span>
    </div>
  );
}
